import { CircularProgress, Flex, Text } from "@chakra-ui/react";

type Props = {
  size?: string;
  color?: string;
  thickness?: string;
  loadingText?: string;
};

export const Loader = ({
  size = "160px",
  thickness = "3px",
  color = "blue.400",
  loadingText = "",
}: Props) => {
  return (
    <Flex
      direction={"column"}
      alignItems="center"
      justifyContent="center"
      h="fit-content"
    >
      <CircularProgress
        thickness={thickness}
        size={size}
        capIsRound={true}
        isIndeterminate
        color={color}
      />
      {loadingText !== "" && (
        <Text whiteSpace={"nowrap"} fontSize="sm">
          {loadingText}
        </Text>
      )}
    </Flex>
  );
};
